import { call } from 'redux-saga/effects';
import { kickUsers } from 'features/users/actions';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';

export function* kickUsersSaga(action: ReturnType<typeof kickUsers>) {
  logger
    .remote({ action: true, tier: 1 })
    .info(`The user removed all users with the role ${action.payload}`);

  yield call(SignalingSocket.send, {
    event: 'kickUsers',
    data: {
      role: action.payload,
    },
  });
}
